import styled from "styled-components";

export const Asterisk = styled.span`
  &:before {
    content: "*";
    color: #ff6666;
  }
`;

export const Relative = styled.div`
  position: relative;
  width: 100%;
`;
